module.exports = __webpack_public_path__ + "img/twitter-sm.0e68e2a4.svg";